import { Component, OnInit } from '@angular/core';
import { LoadService } from '../../services/load.service';
import { TagsService } from '../../services/tags.service';


@Component({
  selector: 'app-reingresocajas',
  templateUrl: './reingresocajas.component.html',
  styleUrls: ['./reingresocajas.component.css']
})
export class ReingresocajasComponent implements OnInit {
  public fileReaded:any;
  constructor(private _tagsService:TagsService,private _loaddata: LoadService) {
    
  }

  ngOnInit() {
  }

  csv2Array(fileInput: any){
    //lee el archivo del input
    this.fileReaded = fileInput.target.files[0];
    
    let reader: FileReader = new FileReader();
    reader.readAsText(this.fileReaded);
    
     reader.onload = (e) => {
      let csv: any = reader.result;
      let allTextLines = csv.split(/\r|\n|\r/);
      let cabeceras = allTextLines[0].split(';');
      let lineas = [];
      
        for (let i = 0; i < allTextLines.length; i++) {
            // separa el contenido (que esta entre punto y coma)
            let data = allTextLines[i].split(';');
            if (data.length === cabeceras.length) {
              let tarr = [];
              for (let j = 0; j < cabeceras.length; j++) {
                tarr.push(data[j]);
              }
            //prefijo esta en tarr[0] y sufijo en tarr[1]
            // log de cada fila
            //  console.log(tarr);
            lineas.push({"prefijo":tarr[0],"sufijo":tarr[1]});
          }
        }

        // all rows in the csv file 
        let json = this.getJsonTags(lineas);
        this._tagsService.stock_up(json).subscribe(
          (response:any) => {
            console.log('respuesta stock_up',response);
          },
          (error) => {
            console.log('error stock up',error);
          }
        );
      } 
    }

    getJsonTags(data:any[]){
      let coma = ',';
      let body = `{ "data":[`;
      let pos = 0;
      for(let caja of data){
        if((pos+1) === data.length){
          coma = '';
        }
        body+=`{
                 "prefix":"${caja.prefijo}",
                 "suffix":"${caja.sufijo}"
               }${coma}`;
        pos++;
      }
      body+=`]}`;
      console.log("BODY PETICION ACTUALIZAR TAGS: ", body);
      return body;
    }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/reingresocajas/reingresocajas.component.ts